import ReportController from './report.controller';

export default class FitPaxReportController extends ReportController
{
	get endpoint() {
		return 'fit-pax';
	}

	get title() {
		return 'FIT Pax Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/fit-pax.report.controller.js
 **/